import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDepartment(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2v2h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2v-2H8v2h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2v-2H4a1 1 0 0 1-1-1V4Zm2 1v4h14V5H5Zm0 10v4h4v-4H5Zm10 4v-4h4v4h-4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
